import ViewBase from "../../../../framework/core/mvvm/view_base";
import AudioManager from "../../../../manager/audio_manager";
import Utility from "../../../../utility/utility";
import { friend_utils } from "./friend_utils";
import LanguageManager from "../../../../manager/language_manager";
import ModuleManager from "../../../../framework/core/module_manager";
import EventManager from "../../../../manager/event_manager";


const {ccclass, property} = cc._decorator;


@ccclass
export default class FriendTransferView extends ViewBase {

    @property(cc.Label)
    transferLabel : cc.Label = null;

    @property(cc.Label)
    transferMax : cc.Label = null;

    @property(cc.Label)
    currencyLab : cc.Label = null;

    @property(cc.Slider)
    slider : cc.Slider = null;

    @property(cc.ProgressBar)
    progressBar : cc.ProgressBar = null

    @property(cc.Button)
    minBtn : cc.Button = null;

    @property(cc.Button)
    maxBtn : cc.Button = null;

    @property(cc.Label)
    minLabel : cc.Label = null;

    @property(cc.Label)
    maxLabel : cc.Label = null;

    @property(cc.Label)
    serviceLabel : cc.Label = null;

    @property(cc.Node)
    grayBarNode : cc.Node = null;

    private friendId : number;

    private friendData : any

    private ownCurrency : number = 0;

    private curTake : number = 0;

    /**
     * 最大转账值(配置值)
     */
    private maxTransValue : number = 10000;

    private minTransValue : number = 1000;

    /**
     * 可转账余额
     */
    private transferRemain : number = 5000 ;

    private isSound = false;

    private lastTakeValue : number ;


    onLoad(){

        this.slider.node.on('slide',this.onSlider,this);
    }


    /**
     * 可转账的金额
     */
    private get transferNum(){
        //return Math.floor(this.ownCurrency * (1 - friend_utils.transferTaxes));
        return this.ownCurrency;
    }

    private onSlider(){        
        this.updateSlider();
    }

    private playWeelSound(){
        if (!this.isSound) {
            AudioManager.instance.playSound("package/texasholdem/sound/choumamove", false, null);
            this.isSound = true;
            this.scheduleOnce(()=>{
                this.isSound = false;
            },0.1);
        }
    }

    private updateSlider(){
    
        let min = Math.min(this.transferNum,this.transferRemain);
        if (min < this.minTransValue || min < 2 * this.minTransValue) {
            
            this.slider.progress = 0;
            this.setBtnGrey(this.maxBtn,true);        
            this.curTake = min;
        }
        else {

            if (this.slider.progress >= this.limitProgress) {                        

                this.slider.progress = this.limitProgress;                                

                this.setBtnGrey(this.maxBtn, true)    
    
            }else{

                let proValue  = this.getVolume * this.slider.progress;
                //找到最适合的步进                
                let step = Math.floor(proValue / this.minTransValue); 
                proValue = step * this.minTransValue;
                
                if ( (this.maxTakeValue - (proValue + this.minTransValue)) < this.minTransValue) {
                    
                    //小于一个步进
                    this.slider.progress = this.limitProgress;                                
                    this.setBtnGrey(this.maxBtn, true)     

                }else{

                    this.setBtnGrey(this.maxBtn, false);                                             
                    this.slider.progress =  ( proValue > 0? proValue + 0.1 : proValue) / this.getVolume;
                }                                
                          
            }  

            this.curTake = Math.floor(this.slider.progress * this.getVolume) + this.minTransValue;
                            
        }

        this.transferLabel.string = Utility.numberFormat(this.curTake) 
        this.setBtnGrey(this.minBtn, this.slider.progress == 0)
        this.progressBar.progress = this.slider.progress;

        if (this.slider.progress != 0 && this.slider.progress != this.limitProgress && this.lastTakeValue != this.curTake) {            
            this.playWeelSound();
        }

        this.lastTakeValue = this.curTake;
        
    }

    onEnable(){

    }

    /**
     * 根据自身携带的货币 算出限制值
     */
    private get limitProgress(){
        
        let minValue = Math.min(this.transferRemain,this.transferNum);

        return Math.min ((minValue  - this.minTransValue)/ this.getVolume,1); 
        
    }

    /**
     * 最大可携带的值
     */
    private get maxTakeValue(){

        return Math.min(this.transferRemain,this.transferNum);
    }

    /**
     * 最大值 - 最小值
     */
    private get getVolume(){
        return this.maxTransValue - this.minTransValue;
    }



    updateCurrency(currency : number){
        this.currencyLab.string = Utility.numberFormat(currency);
    }


    show(currency : number, transferRemain : number, friendData : any){

        this.node.active = false;
        let self = this;
        friend_utils.reqSysConfig((config)=>{

            self.minTransValue = Number(config["player.min.transfer.num"]);
            self.maxTransValue = Number(config["player.day.transfer.num"]);

            self.minLabel.string = Utility.numberFormat(self.minTransValue);
            self.maxLabel.string = Utility.numberFormat(self.maxTransValue);

            self.transferMax.string = "/" + Utility.numberFormat(self.maxTransValue)

            self.ownCurrency = currency;

            self.updateCurrency(currency);
    
            self.friendData = friendData;
            self.friendId = friendData.friendId;     
    
            self.transferRemain = transferRemain;
            self.slider.progress = self.limitProgress;
            
            let taxes = friend_utils.transferTaxes;
            if (taxes > 0) {
                self.serviceLabel.string = (taxes * 100).toString() + "%";    
                self.serviceLabel.node.active = true;
            }else{
                self.serviceLabel.node.active = false;
            }
            
    
            self.node.active = true;
    
            self.updateSlider();
        },true);

    }

    onTransfer(){
        
        Utility.playButtonSound();

        //这里是一共的扣除数
        //let allTake = Math.floor(this.curTake / (1 - friend_utils.transferTaxes));

        //let taxesValue  = allTake - this.curTake;

        //let taxesStr = `(ค่าธรรมเนียม ${friend_utils.transferTaxes * 100}% = ${taxesValue})`;

        let text = LanguageManager.t("friend_transfer_tip").format(this.friendData.nickname,this.curTake );
        ModuleManager.instance.showDialogConfirmCancel(text,()=>{
            let self = this;
            friend_utils.reqTransfer(this.curTake,this.friendId,(result)=>{            
                self.node.active = false;
                if (result) {                
                    friend_utils.getTodayRemain((remain)=>{                
                        EventManager.instance.dispatch("friend_transfer_remain",remain);
                    });
                    self.updateCurrency(self.ownCurrency - this.curTake);
                    EventManager.instance.dispatch("friend_list_do_action");
                    ModuleManager.instance.toastKey("friend_transfer_success");
                }                    
            });            
        })

    }

    onReduce(){
        Utility.playButtonSound();
        
        //curTake 包括了最小的携带值
        let remainder = (this.curTake - 2 * this.minTransValue);
        this.slider.progress = (remainder > 0? remainder + 0.1 : 0) / this.getVolume ;

        this.updateSlider();
  
    }


    onAdd(){
        
        Utility.playButtonSound();

        //curTake 包括了最小的携带值
        let radio = (this.curTake + 0.1) / this.getVolume;
        this.slider.progress = radio; 

        this.updateSlider();
    }


    setBtnGrey(btn: cc.Button, grey: boolean) {
        btn.interactable = !grey
        btn.enableAutoGrayEffect = grey
        
        if(this.maxBtn == btn){
            this.grayBarNode.active = grey;
        }
    }


}